/*global angular*/
var module = angular.module('ageRangeManager', []);
import { ageRangeToString } from '@kathondvla/age-range-manager';

module.factory('ageRangeManager', ['$q',  function ($q) {
  'use strict';
  let that = {};

  that.ageRangeToString = function(startage, endage) {
    return ageRangeToString(startage, endage);
  };

  return that;
}]);

module.exports = module;



// WEBPACK FOOTER //
// ./web/js/module/age-range-manager/ageRangeManager.js